import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import ArticleList from './ArticleList.vue'
import {store} from './store/store';
import {articleStore} from './store/article-store';

import SocialShare from './SocialShare.vue'
import SocialIcon from './components/SocialIcon'
const SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

Vue.component('social-icon', SocialIcon);
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

Vue.use(VueRouter);

var router = new VueRouter({
  mode: 'history',
  routes: []
});

if(document.getElementById("product-catalog")) {
  new Vue({
    router,
    el: '#product-catalog',
    store: store,
    render: h => h(App)
  });
}

if(document.getElementById("article-list")) {
  new Vue({
    router,
    el: '#article-list',

    store: articleStore,
    render: h => h(ArticleList)
  });
}


new Vue({
  data : {
    overriddeNetworks: {
      "facebook": {
        "sharer": 'https://www.facebook.com/sharer/sharer.php?u=@url',
        "type" : 'popup',
      },
      "email" : {
        "sharer":"mailto:?subject=@title&body=@url%0D%0A%0D%0A",
        "type":"direct"
      },
    },
  },
  el: '#social-share',
  render: h => h(SocialShare)
})




// WEBPACK FOOTER //
// ./src/main.js